import { api } from "../../axios";

export const actions = {

    // Campus
    GetCampusAccess(context, data){
        return api.get(`CampusAccess/ApplicationUser/${data}`);
    },
    GetSingleCampusAccess(context, data){
        return api.get(`CampusAccess/${data}`);
    },
    DeleteCampusAccess(context, data){
        return api.delete(`CampusAccess/${data}`);
    },
    CreateCampusAccess(context, data){
        return api.post(`CampusAccess/CreateCampusAccess`, data);
    },

}